import React from "react";

import {
    Box,
    Fade,
    IconButton,
    makeStyles,
    Paper,
    Popper,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
} from "@material-ui/core";
import { Palette } from "../AppConfig";
import { Button } from "@mui/material";
import { Close, Delete } from "@material-ui/icons";

import { DMapDialog, findDMapping } from "./Helpers/Accounts";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    container: {
        // height: "90%",
        // maxHeight: "800px",
    },
    row: {
        "tr:hover": {
            backgroundColor: "rgb(7, 50, 50, 0.42)",
        },
    },
    rowCell: {
        fontSize: "12px",
        wordBreak: "break-all",
        border: "none",
        padding: "2px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
        "&:hover": {
            backgroundColor: "rgb(7, 177, 77, 0.42)",
            cursor: "pointer",
        },
    },
    categoryHeadingCell: {
        textAlign: "center",
        backgroundColor: Palette.FieldersOrange + " !important",
        padding: "2px !important",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        borderLeft: "1px solid white !important",
        borderRight: "1px solid white !important",
        position: "sticky",
        top: "0px !important",
    },
    categoryHeadingCellBlank: {
        textAlign: "center",
        backgroundColor: "#ffffff !important",
        padding: "2px !important",
        position: "sticky",
        top: "0px !important",
    },
    headingCell: {
        fontSize: "11px",
        border: "none",
        // padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: "#a8a8a8",
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },
    headingCellSubtype: {
        fontSize: "11px",
        border: "none",
        // padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: "#878787",
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },

    headingRow: {
        backgroundColor: Palette.FieldersBlue,
    },
    skylightheadingCell: {
        background: "#5ebba7",
    },
    editor: {
        border: "1px solid grey",
        width: "40px",
    },
    noHover: {
        "&:hover": {
            backgroundColor: "transparent !important",
        },
    },
}));

const ManagePricing = (props) => {
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selected, setSelected] = React.useState(null);
    const [updateText, setUpdateText] = React.useState("");
    const [selectedInd, setSelectedInd] = React.useState(null);
    const [selectedRow, setSelectedRow] = React.useState(null);

    const [code, setCode] = React.useState(null);
    const [name, setName] = React.useState(null);
    const [newMapping, setNewMapping] = React.useState(null);
    const [DMapDialogOpen, setDMapDialogOpen] = React.useState(false);

    const descriptionElementRef = React.useRef(null);

    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    React.useEffect(() => {
        if (newMapping !== null) setDMapDialogOpen(true);
    }, [newMapping]);

    const handleClose = () => {
        setDMapDialogOpen(false);
        setNewMapping(null);
    };

    const handleFileClick = (event, updatedState, ind, val) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(updatedState);
        setSelected(val);
        setSelectedInd(ind);
        if (ind > 0) {
            setUpdateText(Object.values(updatedState)[1]);
        } else {
            setUpdateText(Object.values(updatedState)[0]);
        }
        setOpen((previousOpen) => !previousOpen);
    };

    const handleSave = () => {
        if (props.editCell) {
            let newState = props.value;
            newState[selected].find((o, i) => {
                if (o["CUST CODE"] === selectedRow["CUST CODE"]) {
                    if (selectedInd === 0) {
                        newState[selected][i]["CUST CODE"] = updateText;
                    } else {
                        newState[selected][i]["CUSTOMER NAME 1"] = updateText;
                    }
                    return true;
                }
            });

            setOpen(false);
            props.saveValue(props.editCell.POA, props.editCell.key_path, newState);
            // newState["selected"]
        }
    };

    const classes = useStyles();

    return (
        <>
            <Box onClick={(e) => e.stopPropagation()}>
                <Paper>
                    <Table
                        style={{
                            tableLayout: "fixed",
                            width: "450px",
                            height: "500px",
                            display: "block",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <TableBody>
                            <TableRow style={{ borderBottom: "1px solid" }} hover role="checkbox">
                                <TableCell>CUSTOMER CODE</TableCell>
                                <TableCell>NAME</TableCell>
                            </TableRow>
                            {Object.keys(props.value).map((val) => {
                                if (!Array.isArray(props.value[val])) {
                                    return props.value[val];
                                } else {
                                    return (
                                        <>
                                            <TableRow>
                                                <TableCell>{val}</TableCell>
                                            </TableRow>
                                            {props.value[val].map((element, index) => (
                                                <TableRow style={{ borderBottom: "1px solid" }} hover role="checkbox">
                                                    <TableCell
                                                        className={classes.rowCell}
                                                        autoFocus
                                                        margin="dense"
                                                        id="name"
                                                        type="email"
                                                        fullWidth
                                                        variant="standard"
                                                        onClick={(event) => handleFileClick(event, element, 0, val)}
                                                    >
                                                        {element["CUST CODE"] ?? ""}
                                                    </TableCell>
                                                    <TableCell
                                                        className={classes.rowCell}
                                                        autoFocus
                                                        margin="dense"
                                                        id="name"
                                                        type="email"
                                                        fullWidth
                                                        variant="standard"
                                                        onClick={(event) => handleFileClick(event, element, 1, val)}
                                                    >
                                                        {element["CUSTOMER NAME 1"] ?? ""}
                                                    </TableCell>
                                                    <IconButton
                                                        onClick={(e) => {
                                                            let newState = props.value;
                                                            let newVal = newState[val].filter(
                                                                (e) => e["CUST CODE"] !== element["CUST CODE"]
                                                            );

                                                            newState[val] = newVal;
                                                            props.saveValue(
                                                                props.editCell.POA,
                                                                props.editCell.key_path,
                                                                newState
                                                            );
                                                        }}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </TableRow>
                                            ))}
                                        </>
                                    );
                                }
                            })}
                            <TableRow hover>
                                <TextField
                                    onChange={(e) => {
                                        setCode(e.target.value);
                                    }}
                                    label="CODE"
                                />
                                <TextField
                                    onChange={(e) => {
                                        setName(e.target.value);
                                    }}
                                    label="NAME"
                                />
                            </TableRow>
                            <TableRow hover role="checkbox">
                                <TableCell
                                    className={classes.rowCell}
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    type="email"
                                    fullWidth
                                    variant="standard"
                                    onClick={(e) => {
                                        findDMapping({
                                            code,
                                            name,
                                            props,
                                            setNewMapping,
                                            type: "STANDARD",
                                            setName,
                                            setCode,
                                        });
                                    }}
                                >
                                    ADD STANDARD
                                </TableCell>
                            </TableRow>
                            <TableRow hover role="checkbox">
                                <TableCell
                                    className={classes.rowCell}
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    type="email"
                                    fullWidth
                                    variant="standard"
                                    onClick={(e) => {
                                        findDMapping({
                                            code,
                                            name,
                                            props,
                                            setNewMapping,
                                            type: "CC",
                                            setName,
                                            setCode,
                                        });
                                    }}
                                >
                                    ADD CC
                                </TableCell>
                            </TableRow>
                            <TableRow hover role="checkbox">
                                <TableCell
                                    className={classes.rowCell}
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    type="email"
                                    fullWidth
                                    variant="standard"
                                    onClick={(e) => {
                                        findDMapping({
                                            code,
                                            name,
                                            props,
                                            setNewMapping,
                                            type: "PAT",
                                            setName,
                                            setCode,
                                        });
                                    }}
                                >
                                    ADD PAT
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>
            </Box>
            <Popper
                onClick={(e) => e.stopPropagation()}
                open={open}
                anchorEl={anchorEl}
                transition
                placement="bottom"
                disablePortal={false}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps}>
                        <Paper
                            style={{
                                padding: "0px 5px 5px 5px",
                                background: "rgb(255 179 67 / 96%)",
                                textAlign: "center",
                                paddingTop: "2px",
                                minWidth: "50px",
                                width: "300px",
                                height: "200px",
                            }}
                        >
                            <IconButton
                                aria-label="delete"
                                size="small"
                                onClick={(event) => handleFileClick(event, "")}
                                style={{ color: "black", position: "absolute", right: "20px" }}
                            >
                                <Close />
                            </IconButton>
                            <Box
                                style={{
                                    display: "flex",
                                    flexDirection: "Column",
                                    padding: "10px",
                                    marginTop: "20px",
                                }}
                            >
                                {selectedRow && (
                                    <>
                                        <TextField
                                            value={updateText}
                                            onChange={(e) => {
                                                setUpdateText(e.target.value);
                                            }}
                                        />
                                        <Box style={{ margin: "10px" }}>
                                            <Button onClick={() => setOpen(false)}>Close</Button>
                                            <Button onClick={() => handleSave()}>Save</Button>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </Paper>
                    </Fade>
                )}
            </Popper>
            <DMapDialog
                {...{
                    code,
                    name,
                    props,
                    setCode,
                    setName,
                    newMapping,
                    handleClose,
                    DMapDialogOpen,
                }}
            />
        </>
    );
};

export default ManagePricing;
